import Footer from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/Footer/Footer"
import Hero from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/Hero"
import MissionOverview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/Mission/MissionOverview"
import MissionTimeline from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/Mission/MissionTimeline"
import NewsFeedGroup from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/NewsFeed/NewsFeedGroup"
import NewsFeedOverview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/NewsFeed/NewsFeedOverview"
import Overview from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/FramebaseTemplate/Overview"

const FramebaseTemplate = () => {
  return (
    <div className="flex flex-col">
      <Hero  />
    <Overview  />
    <div className="grid gap-4 md:grid-cols-2 mt-12">
      <MissionOverview  />
      <MissionTimeline  />
    </div>
    <div className="flex flex-col gap-4 lg:gap-8 my-12">
      <NewsFeedOverview  />
      <NewsFeedGroup  />
    </div>

    <Footer  />
    </div>
  )
}

export default FramebaseTemplate